import React from 'react';

const { allocatorProfileSectionTitles } = require('buyside/util/constantsFromRails.json');

import PersonWithBriefcaseIcon from 'buyside/svgs/person_with_briefcase.svg';

import ExecutiveManagement from 'buyside/components/presentation/AllocatorProfileShowPage/AllocatorProfileSection/ExecutiveManagement/executiveManagement';
import InvestmentPreferences from 'buyside/components/presentation/AllocatorProfileShowPage/AllocatorProfileSection/InvestmentPreferences/investmentPreferences';
import InvestmentCriteria from 'buyside/components/presentation/AllocatorProfileShowPage/AllocatorProfileSection/InvestmentCriteria/investmentCriteria';

import ExecutiveManagementForm from 'buyside/components/presentation/AllocatorProfileShowPage/AllocatorProfileForm/ExecutiveManagementForm/executiveManagementForm';
import InvestmentCriteriaForm from 'buyside/components/presentation/AllocatorProfileShowPage/AllocatorProfileForm/InvestmentCriteriaForm/investmentCriteriaForm';

import { executiveManagementSchema } from 'buyside/util/allocatorProfileShowPageValidationSchemata';

export const SECTIONS = Object.keys(allocatorProfileSectionTitles);

export const ICONS = {};

export const TITLES = allocatorProfileSectionTitles;

export const MINIMUM_ATTRIBUTES = {
  executive_management: ['executives'],
  investment_preferences: [
    'sectorPreferences',
    'geographyPreferences',
    'assetClassPreferences',
    'fundTypePreferences',
    'fundStrategyPreferences',
    'aumRangePreferences'
  ],
  investment_criteria: ['investmentCriteria']
};

export const EMPTY_TEXT = {
  default: <div>Section Empty. Click the "Edit" button to add information.</div>
};

export const COMPONENTS = {
  executive_management: ExecutiveManagement,
  investment_preferences: InvestmentPreferences,
  investment_criteria: InvestmentCriteria
};

export const EDIT_FORMS = {
  executive_management: ExecutiveManagementForm,
  investment_criteria: InvestmentCriteriaForm
};

export const EDIT_FORM_BOX_TEXT = {
  executive_management: 'Add bio information for the executive managers at your organization.',
  investment_criteria:
    'Fill out this section to inform SumZero admins of your unique investment restrictions and preferences. This might include minimum AUM size, minimum track record, restricted strategies, and other related information. This information will be used by SumZero admins to improve the quality of recommendations we bring your way.'
};

export const VALIDATION_SCHEMATA = {
  executive_management: executiveManagementSchema
};
